import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators,} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserService } from '../../services/user.service';
import { ReportService } from "../../services/report.service";
import { NotificationsService } from 'angular2-notifications';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}

@Component({
    selector: 'app-multiplier',
    templateUrl: './multiplier.component.html',
    styleUrls: ['./multiplier.component.css']
})
export class MultiplierDialog {
    collateralDepositForm: FormGroup;
    amount: string = '';
    deposit: any = {};
    constructor(
        public dialogRef: MatDialogRef<MultiplierDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public userService: UserService,
        private reportService: ReportService,
        public notifSer : NotificationsService
    ) { }

    async ngOnInit() {
        this.deposit = this.data;
        this.collateralDepositForm = this.fb.group({
            assetId: [this.deposit.assetId, Validators.required],
            amount: [this.deposit.amount, Validators.required],
            multiplier: [1, [Validators.required, Validators.min(1)]],
            multiplier_amount: [this.deposit.amount, Validators.required],
        });
    }
    processCollateralDeposit() {
        const { notif } = defaults;
        try {
            if (this.collateralDepositForm.valid) {
                this.userService.csrf().subscribe(success => {
                    this.collateralDepositForm.value['_csrf'] = success['_csrf'];
                    this.collateralDepositForm.value['_id'] = this.data._id;
                    this.collateralDepositForm.value['userid'] = this.data.userid;
                    this.collateralDepositForm.value['assetid'] = this.data.assetId;
                    this.reportService.processCollateralDeposit(this.collateralDepositForm.value).subscribe(response => {
                        if (response.status) {
                            this.notifSer.success('Success', response.message, notif)
                            // Emit the form data when closing the dialog
        
                            this.dialogRef.close({ success: true, data: response.message });
        
                        } else this.notifSer.error('Error', response.message, notif);
                    }, err => this.notifSer.error('Error', err.error.message, notif))
                })
            }else{
                this.notifSer.error('Error', 'Please add multiplier', notif)
            }
        } catch (error) {
           console.log(error);
        }
    }

    calculateMultiplier() {
        this.collateralDepositForm.get('multiplier_amount')
            .setValue(
                this.collateralDepositForm.get('amount').value 
                * this.collateralDepositForm.get('multiplier').value );
    }
}


// WEBPACK FOOTER //
// ./src/app/collateral-deposit/multiplier/multiplier.component.ts